module.exports = __webpack_public_path__ + "static/media/averta.aafdb27b.woff2";